<!--
    TM-1000002000
    „Meine Anträge" der Consultant-Shell — EINE Tabelle „Laufende Anträge" (nur Vorgänge).

    Die früheren Reiter („Antragsentwürfe" / „Laufende Anträge"), der Entwurfszähler, die Spalte
    „Dokumente" und der Link „Eingereicht am" zum Antrag sind entfallen: diese Shell arbeitet nur
    noch mit Vorgängen. Die Überschrift ist die Kopfzeile des Widgets selbst (siehe buildWidgets) —
    die Kopfzeile bleibt eingeschaltet, denn in ihr sitzt das Drei-Punkte-Menü zur Konfiguration.

    Kein Untertitel über der Liste (Nutzerentscheidung). Neben der Überschrift sitzt der rote Zähler
    der noch nicht erfassten Vorgänge — dieselbe Zahl wie am Menüpunkt.
-->
@if (initialized) {

    @if (loadError) {
        <div class="flex align-items-center gap-2 p-3 border-round-lg surface-100">
            <i class="fa-regular fa-triangle-exclamation text-orange-500"></i>
            <span class="text-sm">{{ loadError }}</span>
        </div>
    } @else if (caseWidget) {

        <mvs-widget [widgetData]="caseWidget"
                    [disableUpdate]="disableUpdate"
                    (onObjectSelect)="handleCaseSelect($event)">
            <!-- TM-1000002000: der rote Zähler neben der Überschrift — dieselbe Zahl wie das Badge am
                 Menüpunkt (CwCaseUncapturedCountService): eigene Vorgänge, die „Erfasst" noch nicht erreicht haben. -->
            @if (uncapturedSeverity) {
                <p-badge content
                         class="ml-2 cw-my-requests-uncaptured-badge"
                         [value]="uncapturedCount.toString()"
                         [severity]="uncapturedSeverity"
                         pTooltip="Vorgänge, die noch nicht erfasst sind (Quick Quote oder Entwurf)"></p-badge>
            }
        </mvs-widget>

    }
}
